import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetListExchangeRates = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = DefaultApi({
                params,
                method: 'get',
                url: urls.GET_EXCHANGE_RATES
            });
            if (data.status === 'success') {
                dispatch(Action.SetGetListExchangeRatesAction(data.data));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetListExchangeRates as SetGetListExchangeRates
} 